export const fr = {
  allOpportunitiesPage: {
    page_title: 'Toutes les événements',
    header_title: 'Opportunités de bénévolat chez {{companyName}}',
    empty_state: {
      title: 'Aucun événement disponible',
      description:
        "Il n'y a actuellement aucune opportunité de bénévolat disponible. Veuillez vérifier plus tard.",
      cta_title: 'Autre chose en tête ?',
    },
    categories: {
      all_events: 'Tous les événements',
      events_near_you: 'Événements près de chez vous',
      causes_aligned: 'Causes alignées avec {{companyName}}',
      team_specific: "Événements spécifiques à l'équipe",
      team_specific_subheader:
        "Événements d'équipe pour {{companyName}}. C'est votre équipe ? N'hésitez pas à vous joindre ! Sinon, trouvez un événement ouvert dans la liste ci-dessus.",
      filtered_events: 'Événements filtrés',
      past_events: 'Événements passés',
      ongoing_events: 'Actions communautaires',
    },
    actions: {
      view_all: 'Voir tout',
      back: 'Retour',
    },
    header: {
      welcome: 'Faisons du bénévolat avec {{companyName}}!',
      filters: {
        location_placeholder: 'Emplacement',
        cause_placeholder: 'Cause',
        search_placeholder: 'Rechercher',
        upcoming: 'À venir',
        past: 'Passé',
        all: 'Tout',
        strategically_aligned: 'Aligné stratégiquement',
        cancelled: 'Annulé',
      },
    },
  },
}
